"use client";
import { signOutAction } from "@/app/(auth-pages)/auth/actions";
import Link from "next/link";
import { ThemeSwitcher } from "./theme-switcher";
import { LogOut, Menu, Printer, RefreshCw } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { navItems } from "@/lib/app/nav-items";
import { useClientPermissions } from "@/hooks/usePermissions";
import { Match } from "effect";
import { Fragment } from "react";
import useRecentProject from "@/hooks/useRecentProject";
import { useAuthStore } from "@/providers/auth-store-provider";

export default function HeaderAuth() {
  const displayName = useAuthStore((state) => state.displayName);
  const hasPermission = useClientPermissions();
  const recentProject = useRecentProject();

  return (
    <div className="flex items-center gap-4">
      <span className="hidden md:inline-block">Hey, {displayName}!</span>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant={"outline"} size="sm">
            Menu <Menu />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-56 print:hidden">
          <div className="md:hidden">
            {navItems.map(
              (item) =>
                (!item.permissions || hasPermission(...item.permissions)) &&
                Match.value(item.type).pipe(
                  Match.when("label", () => (
                    <Fragment key={item.label}>
                      <DropdownMenuLabel>{item.label}</DropdownMenuLabel>
                      <DropdownMenuSeparator />
                    </Fragment>
                  )),
                  Match.when("recentProject", () => {
                    if (!recentProject) return null;
                    const href = `/projects/${recentProject.id}`;
                    return (
                      <Link key={item.label} href={href}>
                        <DropdownMenuItem>
                          {item.icon && <item.icon className="mr-2 text-muted-foreground" size="1rem" />}{" "}
                          {item.label}
                        </DropdownMenuItem>
                      </Link>
                    );
                  }),
                  Match.orElse(
                    () => (
                      <Link key={item.label} href={item.href as string}>
                        <DropdownMenuItem>
                          {item.icon && <item.icon className="mr-2 text-muted-foreground" size="1rem" />}{" "}
                          {item.label}
                        </DropdownMenuItem>
                      </Link>
                    )
                    // <LinkMenuItem item={item} href={item.href as string} />
                  )
                )
            )}
          </div>
          <DropdownMenuLabel>My Account</DropdownMenuLabel>
          <DropdownMenuSeparator />
          {/* <Link href="/account">
            <DropdownMenuItem>Settings TODO</DropdownMenuItem>
          </Link> */}
          <Link href="/account/reset-password">
            <DropdownMenuItem>Change Password</DropdownMenuItem>
          </Link>
          <DropdownMenuItem onClick={() => window.open("mailto:support@powersense.uk", "_blank")}>
            Help &amp; Support
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <ThemeSwitcher />
          <Link href="javascript:window.print();">
            <DropdownMenuItem>
              <Printer className="mr-2 text-muted-foreground" size="1rem" /> Print
            </DropdownMenuItem>
          </Link>
          <Link href="javascript:window.location.reload();">
            <DropdownMenuItem>
              <RefreshCw className="mr-2 text-muted-foreground" size="1rem" /> Reload
            </DropdownMenuItem>
          </Link>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={signOutAction}>
            <LogOut className="mr-2 text-muted-foreground" size="1rem" /> Sign Out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
